<template>
<div>
<sidebar-widget
    @add="modalOpen = true"
    @delete="onDelete($event)"
    @edit="currentRowId = $event; modalOpen = true"
    @versions="currentRowId = $event; versionsModalIsOpen = true"
    :rows="rows"
    :headers="['Filing Status']"
>
    <template v-slot:title>Tax Tables</template>

    <template v-slot:row-details="props">
        <tax-table-version :version="props.row.current_version" />
    </template>
</sidebar-widget>

<tax-table-modal
    v-if="modalOpen"
    :tax="tax"
    :tax-table="currentRow"
    @updated="$emit('updated')"
    @close="modalOpen = false; currentRowId = null"
/>

<versions-modal
    v-if="versionsModalIsOpen"
    :url="`/admin/tax-engine/taxes/${tax.id}/tax-tables/${currentRowId}`"
    @close="currentRowId = null; versionsModalIsOpen = false"
>
    <template v-slot:version="props">
        <tax-table-version :version="props.version" />
    </template>
</versions-modal>

</div>
</template>

<script>
import TaxTableModal from './TaxTableModal'
import SidebarWidget from './SidebarWidget'
import TaxTableVersion from './TaxTableVersion'
import VersionsModal from './VersionsModal'

export default {
    props: ['tax', ],
    components: {TaxTableModal, SidebarWidget, TaxTableVersion, VersionsModal, },
    computed: {
        currentRow() {
            return this.tax.tax_tables.find(x => x.id == this.currentRowId)
        },
        rows() {
            const result = []
            this.tax.tax_tables.forEach(row => {
                row = JSON.parse(JSON.stringify(row))
                row.cells = [
                    row.filing_status ? row.filing_status.name : 'N/A'
                ]
                result.push(row)
            })
            return result
        },
    },
    data() {
        return {
            modalOpen: false,
            versionsModalIsOpen: false,
            currentRowId: null,
        }
    },
    methods: {
        getURL(rowId) {
            if (!rowId) {return}
            return `/admin/tax-engine/taxes/${this.tax.id}/tax-tables/${rowId}`
        },
        onDelete(rowId) {
            if (!confirm("Are you sure?")) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.del(this.getURL(rowId)).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
